import React from "react";
import Button from "../components/button";
import { useStaticQuery, graphql } from "gatsby";
import { _ } from "../utils/i18n";
import ImageLibpixel from "./image-libpixel";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: #1b2636; /* theme.palette.text.primary */
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 0;
  padding: 0;
  background-color: #f8f8f8;
`;
const MaxWidth = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1180px;
  width: 100%;
  margin: 0 auto;
  padding: 60px 0;
  @media (max-width: 1313px) {
    padding: 60px 20px;
  }
  @media (max-width: 450px) {
    flex-direction: column;
    padding: 20px;
  }
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 0 10px 0;
  min-width: 150px;
  @media (max-width: 1313px) {
    padding: 10px 30px;
  }
  @media (max-width: 1025px) {
    padding: 10px;
  }
  @media (max-width: 450px) {
    padding: 20px 10px;
  }
`;
const ColumnTitle = styled.h2`
  font-family: Poppins, sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  text-transform: uppercase;
  @media (min-width: 700px) {
    padding-top: 25px;
  }
  @media (max-width: 450px) {
    margin-bottom: 10px;
  }
`;
const FooterLogo = styled(ImageLibpixel)`
  width: 80;
  filter: saturate(0%) grayscale(100%) brightness(69%) contrast(1000%);
`;
const LinkDiv = styled.div`
  color: #1b2636; /* theme.palette.text.primary */
  padding: 10px 0;

  @media (max-width: 1025px) {
    padding: 5px 0;
  }
`;
const StyledLink = styled.a`
  text-decoration: none;
  color: #1b2636; /* theme.palette.text.primary */
  padding: 10px 0;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 1025px) {
    padding: 5px 0;
  }
`;
const FooterAdress = styled.p`
  color: #1b2636; /* theme.palette.text.primary */
  margin: 0;
`;
const ALink = styled.a`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
const SocialMedia = styled.div`
  padding: 15px 0 0 0;
  display: flex;
`;
const SocialLink = styled.a`
  text-decoration: none;
  color: #1b2636; /* theme.palette.text.primary */
  margin: 0 15px 5px 0;
  width: 30;
  height: 30;
  &:visited {
    color: #1b2636;
  }
`;
const BlueContainer = styled.div`
  width: 100%;
  background-color: #06062b;
  height: 150px;
  padding: 40px 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #fff;
  @media (max-width: 1025px) {
    padding: 40px;
  }
  @media (max-width: 500px) {
    padding: 0;
    height: 220px;
  }
`;
const StyledParagraph = styled.p`
  margin-bottom: 0;
  @media (max-width: 1025px) {
    max-width: 210px;
  }
  @media (max-width: 811px) {
    max-width: 155px;
  }
  @media (max-width: 450px) {
    max-width: none;
    margin-bottom: 15px;
  }
`;
const WhiteLink = styled.a`
  color: #fff;
  text-decoration: none;
  &:visited {
    color: #fff;
    text-decoration: underline;
  }
  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 450px) {
    width: 100%;
    margin-top: 15px;
  }
`;
const BlueContainerInner = styled.div`
  display: flex;
  max-width: 1180px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color:: #06062B;
  @media (max-width: 450px) {
    flex-direction: column;
    padding: 20px;
  }
`;
const ContactButtonWrapper = styled.a`
  text-decoration: none;
  width: 305px !important;
  margin-left: -100px !important;
  @media (max-width: 1025px) {
    margin-left: -50px !important;
  }
  @media (max-width: 769px) {
    margin-left: 0 !important;
  }
  @media (max-width: 450px) {
    padding: 15px !important;
    min-width: 100% !important;
    & * {
      font-size: 1rem !important;
    }
  }
`;

const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 30px;
`;

export default function Footer() {
  const {
    menu1,
    menu2,
    menu3,
    wp: { general },
    site: {
      siteMetadata: { copyright },
    },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          copyright
        }
      }
      wp {
        general: acfThemeGeneralSettings {
          options: acfThemeOptions {
            logo {
              sourceUrl
            }
            siteTitle
            address
            facebookLink
            instagramLink
            linkedinLink
            email
            phone
          }
        }
      }
      menu1: wpMenu(locations: { eq: FOOTER_1 }) {
        menuItems {
          nodes {
            connectedNode {
              node {
                uri
              }
            }
            label
            url
          }
        }
        name
      }
      menu2: wpMenu(locations: { eq: FOOTER_2 }) {
        menuItems {
          nodes {
            connectedNode {
              node {
                uri
              }
            }
            label
            url
          }
        }
        name
      }
      menu3: wpMenu(locations: { eq: FOOTER_3 }) {
        menuItems {
          nodes {
            connectedNode {
              node {
                uri
              }
            }
            label
            url
          }
        }
        name
      }
    }
  `);

  return (
    <footer>
      <Wrapper>
        <MaxWidth>
          <Column>
            <FooterLogo
              alt={_("logotype")}
              width="80"
              height="80"
              src={general.options.logo?.sourceUrl}
            />
            <FooterAdress>{general.options?.address}</FooterAdress>
            <FooterAdress>
              {_("Tel")}:{" "}
              <ALink href={`tel:${general.options.phone?.replace(/ /g, "")}`}>
                {general.options.phone}
              </ALink>
            </FooterAdress>
            <FooterAdress>
              {_("E-post")}:{" "}
              <ALink href={`mailto:${general.options.email}`}>
                {general.options.email}
              </ALink>
            </FooterAdress>
            <SocialMedia>
              <SocialLink
                href={general.options.facebookLink}
                target="_blank"
                rel="noreferrer"
              >
                <StyledIcon icon={faFacebook} />
              </SocialLink>
              <SocialLink
                href={general.options.instagramLink}
                target="_blank"
                rel="noreferrer"
              >
                <StyledIcon icon={faInstagram} />
              </SocialLink>
              <SocialLink
                href={general.options.linkedinLink}
                target="_blank"
                rel="noreferrer"
              >
                <StyledIcon icon={faLinkedin} />
              </SocialLink>
            </SocialMedia>
          </Column>
          {menu1?.name && (
            <Column>
              <ColumnTitle>{menu1.name}</ColumnTitle>
              {menu1.menuItems?.nodes?.map((item, i) => (
                <LinkDiv key={i}>
                  <StyledLink href={item.connectedNode?.node?.uri || item.url}>
                    {item.label.replace("&#038;", "&").replace("&amp;", "&")}
                  </StyledLink>
                </LinkDiv>
              ))}
            </Column>
          )}
          {menu2?.name && (
            <Column>
              <ColumnTitle>{menu2.name}</ColumnTitle>
              {menu2.menuItems?.nodes?.map((item, i) => (
                <LinkDiv key={i}>
                  <StyledLink href={item.connectedNode?.node?.uri || item.url}>
                    {item.label.replace("&#038;", "&").replace("&amp;", "&")}
                  </StyledLink>
                </LinkDiv>
              ))}
            </Column>
          )}
          {menu3?.name && (
            <Column>
              <ColumnTitle>{menu3.name}</ColumnTitle>
              {menu3.menuItems?.nodes?.map((item, i) => (
                <LinkDiv key={i}>
                  <StyledLink href={item.connectedNode?.node?.uri || item.url}>
                    {item.label.replace("&#038;", "&").replace("&amp;", "&")}
                  </StyledLink>
                </LinkDiv>
              ))}
            </Column>
          )}
        </MaxWidth>
        <BlueContainer>
          <BlueContainerInner>
            <StyledParagraph>{copyright}</StyledParagraph>
            <ContactButtonWrapper href={_("/kontakt/")}>
              <Button
                label={_("KONTAKT OSS")}
                variant="primary"
                backgroundColor="#6EBDD3"
              />
            </ContactButtonWrapper>
            <Col>
              <WhiteLink href={_("/personvern/")}>
                {_("Personvernerklæring")}
              </WhiteLink>
              <WhiteLink href={_("/sitemap/")}>{_("Sitemap")}</WhiteLink>
            </Col>
          </BlueContainerInner>
        </BlueContainer>
      </Wrapper>
    </footer>
  );
}
